module.exports = __webpack_public_path__ + "img/apc_desktop.77211f54.png";